import { Map, List, fromJS } from "immutable";
import buildingModelCommentConstants from "../constants/buildingModelCommentConstants";

/**
 * BUILDING MODEL COMMENT reducer redux
 */
const initialState = Map({
	loading: false,
	request: false,
	comments: List(),
	commentsMeta: Map(),
	error: null,
	successMessage: "Success!",
	errorMessage: "Something went wrong",
});

export default (state = initialState, action) => {
	switch (action.type) {
		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_REQUEST:
			return state.set("loading", true).set("request", true).set("error", null);

		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_SUCCESS:
			return state
				.set("loading", false)
				.set("request", false)
				.set("comments", fromJS(action.data || []))
				.set("error", null);

		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_CREATE_SUCCESS:
			return state
				.set("loading", false)
				.set("request", false)
				.set("error", null);

		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_REPLY_SUCCESS:
			return state
				.set("loading", false)
				.set("request", false)
				.set("error", null);

		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_FAILURE:
			return state
				.set("loading", false)
				.set("request", false)
				.set("error", action.error)
				.set("errorMessage", action.error || "Something went wrong");

		case buildingModelCommentConstants.BUILDING_MODEL_COMMENT_SET_SUCCESS_MESSAGE:
			return state.set("successMessage", action.data);

		case buildingModelCommentConstants.CLEAR_BUILDING_MODEL_COMMENTS:
			return state
				.set("comments", List())
				.set("commentsMeta", Map())
				.set("error", null)
				.set("loading", false)
				.set("request", false);

		default:
			return state;
	}
};
